export default "__VITE_ASSET__rZGzkXqH__"